module.exports = __webpack_public_path__ + "static/media/Freestyle.b6b6c03d.ttf";